import { render, staticRenderFns } from "./LayoutDashboard.vue?vue&type=template&id=8a6d1130&scoped=true"
import script from "./LayoutDashboard.vue?vue&type=script&lang=js"
export * from "./LayoutDashboard.vue?vue&type=script&lang=js"
import style0 from "./LayoutDashboard.vue?vue&type=style&index=0&id=8a6d1130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6d1130",
  null
  
)

export default component.exports